import { useState } from "react";
import styles from "./style";
import { Paper, useMediaQuery } from "@material-ui/core";
import { Modal, Tag } from "antd";
import { Col, Form, Row, Select } from "antd";
import type { SelectProps } from "antd";
import CapaOriginWiseChart from "./CapaOriginWiseChart";
import { AiOutlineArrowsAlt } from "react-icons/ai";
import CapaByOriginAndStatusChart from "./CapaByOriginAndStatusChart";
import CloseIconImageSvg from "assets/documentControl/Close.svg";
import CapaTable from "./CapaTable";
import CapaByDepartmentCountGraph from "./CapaByDepartmentCountGraph";
import CapaAllLocationGraph from "./CapaAllLocationGraph";
import CapaforAllDepatmentFilterChart from "./CAPAforAllDepatmnetFilterChart";

type props = {
  capaChartData?: any;
  setSelectedCapaIds?: any;
  showModalCharts?: any;
  newChartData?: any;
  matchedDepartmentName?: any;
  matchedLocationName?: any;
  alllocationData?: any;
  allOption?: any;
  allDepartmentOption?: any;
  tags?: any;
};

const CapaDashBoardCharts = ({
  capaChartData,
  setSelectedCapaIds,
  showModalCharts,
  newChartData,
  matchedDepartmentName,
  matchedLocationName,
  alllocationData,
  allOption,
  allDepartmentOption,
  tags,
}: props) => {
  const matches = useMediaQuery("(min-width:820px)");
  const smallScreen = useMediaQuery("(min-width:470px)");
  const classes = styles(smallScreen, matches)();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenForSecondGraph, setIsModalOpenForSecondGraph] =
    useState(false);
  const [isModalOpenForFirstGraph, setIsModalOpenForFirstGraph] =
    useState(false);

  const showModal = () => {
    setIsModalOpen(true);
    // handleFilterClick();
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const options: SelectProps["options"] = [];

  for (let i = 10; i < 36; i++) {
    options.push({
      label: i.toString(36) + i,
      value: i.toString(36) + i,
    });
  }

  const handleChange = (value: string[]) => {};

  // first graph modal

  const showModalForSecondGraph = () => {
    setIsModalOpenForSecondGraph(true);
  };

  const handleOkForSecondGraph = () => {
    setIsModalOpenForSecondGraph(false);
  };

  const handleCancelForSecondGraph = () => {
    setIsModalOpenForSecondGraph(false);
  };

  // second graph modal

  const showModalForFirstGraph = () => {
    setIsModalOpenForFirstGraph(true);
  };

  const handleOkForFirstGraph = () => {
    setIsModalOpenForFirstGraph(false);
  };

  const handleCancelForFirstGraph = () => {
    setIsModalOpenForFirstGraph(false);
  };

  return (
    <>
      {allOption === "All" || allDepartmentOption === "All" ? null : (
        <div className={classes.filterMainContainer}>
          <div className={classes.textContainer}>
            <Paper elevation={0} className={classes.paper}>
              <p className={classes.count}>{capaChartData?.mydeptcount}</p>
              <p className={classes.text}>My Dept </p>
            </Paper>
          </div>
          <div className={classes.textContainer}>
            <Paper elevation={0} className={classes.paper}>
              <p className={classes.count}>{capaChartData?.myloccount}</p>
              <p className={classes.text}>My Unit</p>
            </Paper>
          </div>
        </div>
      )}

      {allOption === "All" ? (
        ""
      ) : (
        <div className={classes.chartMainContainer}>
          <Paper
            elevation={0}
            style={{
              marginTop: "0px",
              padding: matches ? "15px" : "3px",
              display: "flex",
              border: "1px solid #d7cdc1",
              borderRadius: "5px",
              width: matches ? "60%" : "100%",
              height: "380px",
            }}
          >
            <div style={{ width: matches ? "100%" : "96%", height: "320px" }}>
              {" "}
              {matches ? (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  {tags?.length ? (
                    <>
                      {tags?.map((tag: any, index: any) => (
                        <Tag color={tag.color} key={index}>
                          {tag.tagName}
                        </Tag>
                      ))}
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              ) : null}
              <CapaByOriginAndStatusChart
                capaChartData={capaChartData}
                setSelectedCapaIds={setSelectedCapaIds}
                showModalCharts={showModalCharts}
                matchedLocationName={matchedLocationName}
                allDepartmentOption={allDepartmentOption}
              />
            </div>

            {matches ? (
              <AiOutlineArrowsAlt onClick={showModalForSecondGraph} />
            ) : null}
          </Paper>

          <Paper
            elevation={0}
            style={{
              marginTop: "0px",
              padding: matches ? "15px" : "3px",
              display: "flex",
              border: "1px solid #d7cdc1",
              borderRadius: "5px",
              width: matches ? "37%" : "100%",
              height: "380px",
            }}
          >
            <div style={{ width: matches ? "100%" : "96%", height: "320px" }}>
              {matches ? (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  {tags?.length ? (
                    <>
                      {tags?.map((tag: any, index: any) => (
                        <Tag color={tag.color} key={index}>
                          {tag.tagName}
                        </Tag>
                      ))}
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              ) : null}
              <CapaOriginWiseChart
                capaChartData={capaChartData}
                setSelectedCapaIds={setSelectedCapaIds}
                showModalCharts={showModalCharts}
                matchedDepartmentName={matchedDepartmentName}
              />
            </div>

            {matches ? (
              <AiOutlineArrowsAlt onClick={showModalForFirstGraph} />
            ) : (
              ""
            )}
          </Paper>
        </div>
      )}

      {allOption === "All" ? null : (
        <div style={{ display: "flex", gap: "20px" }}>
          {allDepartmentOption === "All" ||
          allDepartmentOption === undefined ? (
            <Paper
              elevation={0}
              style={{
                marginTop: "15px",
                padding: matches ? "15px" : "3px",
                display: "flex",
                border: "1px solid #d7cdc1",
                borderRadius: "5px",
                width: matches ? "100%" : "94%",
                height: "380px",
                margin: matches ? "20px" : "10px",
              }}
            >
              <div style={{ width: "100%", height: "320px" }}>
                {" "}
                {matches ? (
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    {tags?.length ? (
                      <>
                        {tags?.map((tag: any, index: any) => (
                          <Tag color={tag.color} key={index}>
                            {tag.tagName}
                          </Tag>
                        ))}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                ) : null}
                <CapaforAllDepatmentFilterChart
                  setSelectedCapaIds={setSelectedCapaIds}
                  showModalCharts={showModalCharts}
                  newChartData={newChartData}
                />
              </div>
            </Paper>
          ) : (
            <Paper
              elevation={0}
              style={{
                marginTop: "15px",
                padding: matches ? "15px" : "3px",
                display: "flex",
                border: "1px solid #d7cdc1",
                borderRadius: "5px",
                width: matches ? "100%" : "94%",
                height: "380px",
                margin: matches ? "20px" : "10px",
              }}
            >
              <div style={{ width: "100%", height: "320px" }}>
                {" "}
                {matches ? (
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    {tags?.length ? (
                      <>
                        {tags?.map((tag: any, index: any) => (
                          <Tag color={tag.color} key={index}>
                            {tag.tagName}
                          </Tag>
                        ))}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                ) : null}
                <CapaByDepartmentCountGraph
                  setSelectedCapaIds={setSelectedCapaIds}
                  showModalCharts={showModalCharts}
                  newChartData={newChartData}
                />
              </div>
            </Paper>
          )}
        </div>
      )}

      {allOption === "All" ? (
        <Paper
          elevation={0}
          style={{
            marginTop: "15px",
            padding: matches ? "15px" : "3px",
            display: "flex",
            border: "1px solid #d7cdc1",
            borderRadius: "5px",
            width: matches ? "97%" : "94%",
            height: "480px",
            margin: matches ? "20px" : "10px",
          }}
        >
          <div style={{ width: "100%", height: "370px" }}>
            {" "}
            {matches ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                {tags?.length ? (
                  <>
                    {tags?.map((tag: any, index: any) => (
                      <Tag color={tag.color} key={index}>
                        {tag.tagName}
                      </Tag>
                    ))}
                  </>
                ) : (
                  <></>
                )}
              </div>
            ) : null}
            <CapaAllLocationGraph
              setSelectedCapaIds={setSelectedCapaIds}
              showModalCharts={showModalCharts}
              alllocationData={alllocationData}
              // newChartData={newChartData}
            />
          </div>
        </Paper>
      ) : // </div>
      null}

      <div style={{ margin: "30px" }}>
        <CapaTable
          newChartData={newChartData}
          alllocationData={alllocationData}
          allOption={allOption}
          setSelectedCapaIds={setSelectedCapaIds}
          showModalCharts={showModalCharts}
        />
      </div>

      <Modal
        title="Filter By Unit"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Ok"
      >
        <Form
          //   form={form}
          name="auditDFilters"
        >
          <Row>
            <Col span={24}>
              <Form.Item name="Unit">
                <Select
                  // mode="multiple"
                  allowClear
                  placeholder="Unit"
                  onChange={handleChange}
                  options={options}
                >
                  {/* {locations.map((locationName: any) => (
                    <Select.Option key={locationName} value={locationName}>
                      {locationName}
                    </Select.Option>
                  ))} */}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      {/* // Model for charts */}

      <Modal
        // title="Filter By Unit"
        open={isModalOpenForFirstGraph}
        onOk={handleOkForFirstGraph}
        onCancel={handleCancelForFirstGraph}
        width="90vw"
        style={{ display: "flex", justifyContent: "center" }}
        closeIcon={
          <img
            src={CloseIconImageSvg}
            alt="close-drawer"
            style={{
              width: "30px",
              height: "38px",
              cursor: "pointer",
              marginTop: "-5px",
            }}
          />
        }
        footer={null}
      >
        <div style={{ width: "85vw", height: "60vh" }}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {tags?.length ? (
              <>
                {tags?.map((tag: any, index: any) => (
                  <Tag color={tag.color} key={index}>
                    {tag.tagName}
                  </Tag>
                ))}
              </>
            ) : (
              <></>
            )}
          </div>

          <CapaOriginWiseChart
            capaChartData={capaChartData}
            setSelectedCapaIds={setSelectedCapaIds}
            showModalCharts={showModalCharts}
            matchedDepartmentName={matchedDepartmentName}
          />
        </div>
      </Modal>

      <Modal
        // title="Filter By Unit"
        open={isModalOpenForSecondGraph}
        onOk={handleOkForSecondGraph}
        onCancel={handleCancelForSecondGraph}
        width="90vw"
        style={{ display: "flex", justifyContent: "center" }}
        closeIcon={
          <img
            src={CloseIconImageSvg}
            alt="close-drawer"
            style={{
              width: "30px",
              height: "38px",
              cursor: "pointer",
              marginTop: "-5px",
            }}
          />
        }
        footer={null}
      >
        <div style={{ width: "85vw", height: "60vh" }}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {tags?.length ? (
              <>
                {tags?.map((tag: any, index: any) => (
                  <Tag color={tag.color} key={index}>
                    {tag.tagName}
                  </Tag>
                ))}
              </>
            ) : (
              <></>
            )}
          </div>
          <CapaByOriginAndStatusChart
            capaChartData={capaChartData}
            setSelectedCapaIds={setSelectedCapaIds}
            showModalCharts={showModalCharts}
            matchedLocationName={matchedLocationName}
            allDepartmentOption={allDepartmentOption}
          />
        </div>
      </Modal>
    </>
  );
};

export default CapaDashBoardCharts;
